import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { TooltipModule } from 'primeng/tooltip';
import { GreentripperPinIconComponent } from '../../../shared/components/greentripper-pin-icon/greentripper-pin-icon.component';
import { CurrentUserService } from '../../../shared/services/current-user.service';

@Component({
  selector: 'app-contribution-cta',
  standalone: true,
  imports: [CommonModule, TranslocoModule, TooltipModule, GreentripperPinIconComponent],
  templateUrl: './contribution-cta.component.html',
  styles: [],
})
export class ContributionCtaComponent {
  @Input() tripId: string = '';
  @Input() tripName: string = '';
  @Input() co2Impact: number = 0;

  private router = inject(Router);
  private currentUserService = inject(CurrentUserService);
  isSuperAdmin = this.currentUserService.isSuperAdmin;

  onDiscoverProjects(): void {
    if (this.tripId) {
      this.router.navigate(['/home/trips', this.tripId, 'contribute']);
    }
  }

  onLearnMore(): void {
    // TODO: Modal or information page about contributions
  }
}
